module.exports = __webpack_public_path__ + "img/sure_join.421c0ac1.png";